import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ExternalLink, ArrowUpRight, ArrowDownRight, } from "lucide-react";
// import { useApiCall } from "../../../../../component/custom-hooks/api-call";
// import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import { Link } from "react-router";
// import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableHead, TableHeaderWrap, TableMaxTags, TableRow } from "../../../../../component/table/table-layout";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableHead, TableHeaderWrap, TableMaxTags, TableRow } from "../../../../../component/table/table-layout";

export default function WorkForceQuickView({ open = true, onClose = () => { }, apiKey, apiUrl, pagUrl, title, icon, subTitle, stateLable, positive = null, positiveIcon = true, }) {
  const containerRef = useRef(null);
  const apiCall = useApiCall();
  const [head, setHead] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(false)
    try {
      const res = await apiCall({ method: "get", url: apiUrl });
      setHead(res?.headers);
      setData(res[apiKey] || []);
      setIsLoading(true);
    } catch (error) {
      console.log("Error : ", error);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      getData();
    }, 50);
  }, [apiUrl])

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.aside
            ref={containerRef}
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 40, opacity: 0 }}
            transition={{ type: "spring", stiffness: 380, damping: 32 }}
            className="relative mt-auto mr-[2vh] mb-auto ml-0 flex h-[96vh] w-[750px] max-w-[98vw] flex-col overflow-hidden rounded-[10px] border border-solid border-slate-200 bg-gradient-to-b from-white to-slate-50 shadow-xl"
            aria-modal
            role="dialog"
          >
            {
              isLoading ? (
                <>
                  {/* Header */}
                  <div className="border-b border-solid border-slate-200 bg-white/90 py-2 backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                    <div className="flex flex-wrap items-center justify-between gap-3 w-full">
                      <div className="flex min-w-0 items-center gap-3">
                        <div className="text-lg bg-gradient-to-br from-indigo-500/10 to-emerald-500/10 grid place-items-center font-medium rounded-md w-11 h-11">{icon}</div>
                        <div className="flex flex-col gap-0">
                          <h2 className="truncate text-lg font-semibold tracking-tight text-slate-900 flex gap-2 items-center">
                            {title}

                            {positive != null && (
                              <span
                                className={`flex items-center text-xs px-2 py-0.5 rounded-full ${positive
                                  ? "bg-green-100 text-green-700"
                                  : "bg-red-100 text-red-700"
                                  }`}
                              >

                                {
                                  positiveIcon ? (
                                    positive ? (
                                      <ArrowUpRight className="h-3 w-3 mr-1" />
                                    ) : (
                                      <ArrowDownRight className="h-3 w-3 mr-1" />
                                    )
                                  ) : null
                                }
                                {stateLable}
                              </span>
                            )}
                          </h2>
                          <p className="text-sm text-slate-400">{subTitle}</p>
                        </div>
                      </div>

                      <div className="flex flex-wrap items-center gap-2">
                        <Link
                          to={`${pagUrl}`}
                          className="inline-flex items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                        // onClick={() => window.alert("Opening full profile… (wire to route)")}
                        >
                          <ExternalLink className="size-4" /> View Full
                        </Link>
                        <button
                          className="inline-flex items-center gap-1.5 rounded-xl bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                          onClick={onClose}
                          aria-label="Close"
                        >
                          <X className="size-4" /> Exit
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Body */}
                  <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 overflow-hidden py-[10px] w-full">
                    <TableCard>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell header><TableHeaderWrap><span>Name</span></TableHeaderWrap></TableCell>
                            {head.map((ele, idx) => {
                              if (ele?.show_popup) {
                                return (
                                  <TableCell header key={`th-${idx}`}><TableHeaderWrap><span>{ele?.value}</span></TableHeaderWrap></TableCell>
                                )
                              } else {
                                return null;
                              }
                            })}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {data.map((ele, idx) => (
                            <TableRow key={ele.id || idx}>
                              <TableCell>
                                <div className="flex items-center gap-3 pr-2 pl-1">
                                  {ele?.profile_picture ? (
                                    <img
                                      className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                      src={ele?.profile_picture}
                                      alt={ele?.name}
                                      onError={(e) => {
                                        e.currentTarget.onerror = null; // prevent infinite loop
                                        e.currentTarget.style.display = "none"; // hide broken img
                                        e.currentTarget.nextSibling.style.display = "grid"; // show initials div
                                      }}
                                    />
                                  ) : null}
                                  <div
                                    style={{ display: ele?.profile_picture ? "none" : "grid" }}
                                    className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium"
                                  >
                                    {ele?.name?.split(" ")[0]?.charAt(0) ?? ""}
                                    {ele?.name?.split(" ")[1]?.charAt(0) ?? ""}
                                  </div>
                                  <div>
                                    <div className="font-semibold text-[15px] leading-5">{ele?.name}</div>
                                  </div>
                                </div>
                              </TableCell>
                              {
                                head.map((h_ele, h_idx) => {
                                  if (h_ele?.show_popup) {
                                    if (h_ele?.key === "emp_is_active" || h_ele?.key?.includes("status")) {
                                      return (
                                        <TableCell key={`td-${h_idx}`} className={`text-center`}>
                                          {(ele[h_ele?.key]) ?
                                            <>
                                              {
                                                (ele[h_ele?.key] === 'Active' || ele[h_ele?.key]?.toLowerCase() === 'approved' || ele[h_ele?.key]?.toLowerCase() === 'approve') ? (
                                                  <div
                                                    className={`px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium`}
                                                    style={{ backgroundColor: "#ECF6DC", color: '#16432B' }}
                                                  >
                                                    {ele[h_ele?.key]}
                                                  </div>
                                                ) : (ele[h_ele?.key]?.toLowerCase() === 'pending' || ele[h_ele?.key]?.toLowerCase() === 'expiring soon') ? (
                                                  <div
                                                    className={`px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium`}
                                                    style={{ backgroundColor: "#EEF8FF", color: '#243F52' }}
                                                  >
                                                    {ele[h_ele?.key]}
                                                  </div>
                                                ) : (
                                                  <div
                                                    className={`px-[20px] py-[8px] inline-flex rounded-2xl text-center text-[12px] font-medium`}
                                                    style={{ backgroundColor: "#E4CCD7", color: '#5E203C' }}
                                                  >
                                                    {ele[h_ele?.key]}
                                                  </div>
                                                )
                                              }
                                            </>
                                            :
                                            "--"
                                          }
                                        </TableCell>

                                      )
                                    } else if (h_ele?.key === "tenure_value") {
                                      return (
                                        <TableCell key={`td-${h_idx}`}>
                                          {ele?.tenure || '--'}
                                        </TableCell>
                                      )
                                    } else if (h_ele?.key === "missing_fields") {
                                      return (
                                        <TableCell key={`td-${h_idx}`}>
                                          <TableMaxTags
                                            className={`!w-[350px]`}
                                            values={ele?.missing_fields}
                                          />
                                          {/* {ele?.missing_fields || '--'} */}
                                        </TableCell>
                                      )
                                    } else if (h_ele?.key === "department_name") {
                                      return (
                                        <TableCell key={`td-${h_idx}`} className={`text-center`}>
                                          <TableDepartmentTag title={ele[h_ele?.key] || '--'} />
                                        </TableCell>
                                      )
                                    } else if (h_ele?.key === "emp_emptype") {
                                      return (
                                        <TableCell key={`td-${h_idx}`} className={`text-center`}>
                                          {
                                            (ele[h_ele?.key] === 'Permanent') ? (
                                              <div
                                                className={`px-[20px] py-[8px] rounded-2xl text-center text-[12px] font-medium inline-flex`}
                                                style={{ backgroundColor: "#ECF6DC", color: '#16432B' }}
                                              >
                                                {ele[h_ele?.key] || '--'}
                                              </div>
                                            ) : (ele[h_ele?.key] === 'Internship') ? (
                                              <div
                                                className={`px-[20px] py-[8px] rounded-2xl text-center text-[12px] font-medium inline-flex`}
                                                style={{ backgroundColor: "#EDEDED", color: '#3D3E3E' }}
                                              >
                                                {ele[h_ele?.key] || '--'}
                                              </div>
                                            ) : (
                                              <div
                                                className={`px-[20px] py-[8px] rounded-2xl text-center text-[12px] font-medium inline-flex`}
                                                style={{ backgroundColor: "#FAF1E2", color: '#0E121B' }}
                                              >
                                                {ele[h_ele?.key] || '--'}
                                              </div>
                                            )
                                          }
                                        </TableCell>
                                      )
                                    } else if (h_ele?.key === "email" || h_ele?.key === "p_personal_email") {
                                      return (
                                        <TableCell key={`td-${h_idx}`}>
                                          {
                                            ele[h_ele?.key] ?
                                              <a href={`mailto:${ele[h_ele?.key]}` || ''}>
                                                {ele[h_ele?.key] || '--'}
                                              </a>
                                              :
                                              "--"
                                          }
                                        </TableCell>
                                      )
                                    } else {
                                      return (
                                        <TableCell key={`td-${h_idx}`}>
                                          {ele[h_ele?.key] || '--'}
                                        </TableCell>
                                      )
                                    }
                                  } else {
                                    return null;
                                  }
                                })
                              }
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableCard>
                  </div>
                </>
              ) : (
                <InnerLoader wrapperClass={'w-full'} />
              )
            }

          </motion.aside>
        </motion.div>
      )}
    </AnimatePresence>
  );
}